<template>
  <div>
    <!-- <div v-if="hasMta"> -->
    <div v-if="hasUser">
      <div v-if="cardList.length > 0" class="columns">
        <div class="column col-12 col-mx-auto">
          <div class="columns">
            <div class="text__error">{{ getCaption("caption.card_detail.note1.title") }}</div>
            <div class="column text-justify" v-html="getCaption('caption.card_detail.note1.body')"></div>
          </div>
          <div class="columns">
            <div class="text__error">{{ getCaption("caption.card_detail.note2.title") }}</div>
            <div class="column text-justify" v-html="getCaption('caption.card_detail.note2.body')"></div>
          </div>
          <div class="columns">
            <div class="text__error">{{ getCaption("caption.card_detail.note3.title") }}</div>
            <div class="column text-justify" v-html="getCaption('caption.card_detail.note3.body')"></div>
          </div>
          <div class="columns">
            <div class="text__error">{{ getCaption("caption.card_detail.note4.title") }}</div>
            <div class="column text-justify" v-html="getCaption('caption.card_detail.note4.body')"></div>
          </div>
        </div>
        <div class="column col-12 col-mx-auto">
          <div class="columns my-2 py-2">
            <div class="column col-xs-12 col-sm-11 col-md-7 col-5 col-mx-auto">
              <div class="form-horizontal">
                <div class="form-group">
                  <div class="col-3 col-sm-12">
                    <strong>
                      <label
                        class="form-label"
                        for="input-example-1"
                      >{{ getCaption("caption.card_name") }}</label>
                    </strong>
                  </div>
                  <div class="col-9 col-sm-12">
                    <select
                      v-model="selectedId"
                      class="form-select rounded text-center form-select--placeholder focus-purple"
                      required
                    >
                      <option value hidden selected>{{ this.getCaption("caption.card_name") }}</option>
                      <option
                        v-for="(card, i) in cardList"
                        :key="i"
                        :value="card.id"
                      >{{ card.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="cardDetail" class="mt-2 pt-2">
            <div v-if="cardDetail.length == 0" class="text-center mt-2 pt-2">
              <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
            </div>
            <div v-else-if="cardDetail.transactions.length > 0">
              <h5
                class="text-right"
              >{{ getCaption("caption.ebarimt_count") + " : " + (cardDetail.card ? cardDetail.card.ebarimtCount : "0") }}</h5>

              <table class="table table-responsive table-striped">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>{{ getCaption("caption.paid_date") }}</th>
                    <th>{{ getCaption("caption.card_type") }}</th>
                    <th>{{ getCaption("caption.direction_number") }}</th>
                    <th>{{ getCaption("caption.terminal") }}</th>
                    <th>{{ getCaption("caption.passenger_quant") }}</th>
                    <th>{{ getCaption("caption.card_transaction_amont") }}</th>
                    <th>{{ getCaption("caption.card_balance") }}</th>
                    <th>{{ getCaption("caption.vehicle_number") }}</th>
                    <th>{{ getCaption("caption.get_off_in") }}</th>
                    <th>{{ getCaption("caption.ebarimt_send_date") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(transaction, i) in cardDetail.transactions" :key="i">
                    <td class="table__key">
                      <div class="table__cell--label">№</div>
                      <div class="table__cell--content">{{ i + 1 }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.paid_date") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? formatString(transaction.tranOccrDt, [4,6], "-") + " " + formatString(transaction.tranOccrTm, [2,4], ":") : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.card_type") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? getCaption(transaction.type) : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.direction_number") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? transaction.lineName : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.terminal") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? transaction.stationName : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.passenger_quant") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? transaction.PsngrCnt : "-" }}</div>
                    </td>
                    <td>
                      <div
                        class="table__cell--label"
                      >{{ getCaption("caption.card_transaction_amont") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? transaction.tranAmt + " ₮" : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.card_balance") }}</div>
                      <div class="table__cell--content">
                        <span v-if="!transaction">-</span>
                        <span
                          v-else-if="transaction.afterAmountType == 1"
                        >{{ transaction.cardAftBalAmt }} {{ getCaption("caption.card_balance_count") }}</span>
                        <span v-else>{{ transaction.cardAftBalAmt }} ₮</span>
                      </div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.vehicle_number") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? formatString(transaction.grgNo, [2], "-") : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.get_off_in") }}</div>
                      <div
                        class="table__cell--content"
                      >{{ transaction ? transaction.getOnoffCd == 0 ? getCaption("caption.get_in") : getCaption("caption.get_off") : "-" }}</div>
                    </td>
                    <td>
                      <div class="table__cell--label">{{ getCaption("caption.ebarimt_send_date") }}</div>
                      <div class="table__cell--content">
                        <template v-if="transaction">
                          <span
                            v-if="transaction.ebarimtStatus == 0"
                          >{{ getCaption("caption.transaction_status_travel") }}</span>
                          <template v-else-if="transaction.ebarimtStatus == 1">
                            <!-- <button
                              class="btn btn--color-orange rounded"
                              v-if="transaction.ebarimtReqStatus == 'ready'"
                              @click="sendEbarimt(transaction, i)"
                            >
                              <span>{{ getCaption("caption.ebarimt_get_button") }}</span>
                            </button>
                            <div
                              v-else-if="transaction.ebarimtReqStatus == 'loading'"
                              class="loader--sm"
                            ></div> -->
                            <span
                              v-html="getCaption('caption.transaction_status_travel')"
                            ></span>
                          </template>
                          <span
                            v-else-if="transaction.ebarimtStatus == 2"
                            v-html="getCaption('caption.transaction_status_travel')"
                          ></span>
                          <span
                            v-else-if="transaction.ebarimtStatus == 3"
                          >{{ getCaption("caption.transaction_status_transfered") }}</span>
                          <span
                            class="tran_discounted"
                            v-else-if="transaction.ebarimtStatus == 4"
                            v-html="getCaption('caption.transaction_status_discounted')"
                          ></span>
                        </template>
                        <span v-else>-</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-center mt-2 pt-2">
        <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
      </div>
    </div>
    <!-- <div v-else class="d-flex justify-content-center">
      <div class="col-xs-11 col-sm-10 col-md-6 col-4">
        <div class="toast toast-error my-2">{{ getCaption("caption.mta_check_description") }}</div>
        <div class="form-group">
          <button
            type="button"
            class="btn btn--color-purple btn--width-full rounded"
            @click="checkMta()"
          >
            <div v-if="mtaCheckStatus === 'PENDING'" class="loader--sm"></div>
            <span v-else>{{ this.getCaption("caption.mta_check_button") }}</span>
          </button>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import OtherService from "@/services/OtherService.js";
import CardService from "@/services/CardService.js";
import UserService from "@/services/UserService";

export default {
  data() {
    return {
      cardList: [],
      selectedId: "",
      cardDetail: null,
      mtaCheckStatus: null
    };
  },

  computed: {
    cardId() {
      return this.$route.query.cardId;
    },

    hasMta: function() {
      return (
        this.$store.state.loggedUser &&
        this.$store.state.loggedUser.mtaAccount != null
      );
    },

  hasUser: function() {
      return (
        this.$store.state.loggedUser
      );
    },

    currentPath() {
      return this.$router.currentRoute.path;
    }
  },

  watch: {
    hasMta: function(val) {
      if (val) this.getCardList();
    },

    selectedId: function(id) {
      var url = window.location.href;
      var urlSplit = url.split("?");
      var obj = { Title: document.title, Url: urlSplit[0] + "?cardId=" + id };
      history.replaceState(obj, obj.Title, obj.Url);

      if (id) this.getCardDetail(id);
    }
  },

  created() {
    if (!this.isAuth()) {
      this.$router.replace({ name: "SignIn" });
    }
  },

  mounted() {
    if (this.hasUser) this.getCardList();
    if (this.cardId) this.selectedId = this.cardId;
  },

  methods: {
    checkMta() {
      this.mtaCheckStatus = "PENDING";
      OtherService.checkMta()
        .then(response => {
          this.showToast(this.getCaption(response.data.payload.toast), true);
          UserService.userInfo().then(response => {
            this.$store.dispatch("setUser", response.data.payload);
            this.mtaCheckStatus = "";
          });
        })
        .catch(error => {
          this.mtaCheckStatus = "";
        });
    },

    getCardList() {
      CardService.getCardList().then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.cardList = response.data.payload;
          if (this.selectedId === "" && this.cardList.length > 0)
            this.selectedId = this.cardList[0].id;
        }
      });
    },

    getCardDetail(id) {
      const data = JSON.parse("{}");
      data.id = id;
      CardService.getCardDetail(data)
        .then(response => {
          if (response.status == 200 && response.data.success == true) {
            let res = response.data.payload;
            if (res.length !== 0)
              res.transactions.forEach(transaction => {
                transaction.ebarimtReqStatus = "ready";
              });
            else {
              res = {};
              res.transactions = [null];
            }
            this.cardDetail = res;
          }
        })
        .catch(error => {
          if (
            error.response &&
            error.response.status === 422 &&
            error.response.data.payload.errors[0].name === "fatal"
          ) {
            this.$router.push("/card-register");
            this.showToast(
              this.getCaption(error.response.data.payload.errors[0].message),
              false
            );
          }
        });
    },

    sendEbarimt(transaction, i) {
      transaction.ebarimtReqStatus = "loading";

      CardService.sendEbarimt({
        tranUnqNo: transaction.tranUnqNo
      })
        .then(response => {
          let res = response.data;
          if (res.success) {
            this.cardDetail.card.ebarimtCount = res.payload.ebarimtCount;
            transaction.ebarimtReqStatus = "sent";
          }
        })
        .catch(err => {
          this.$snotify.error(
            this.getCaption(err.response.data.payload.errors[0].message)
          );
          transaction.ebarimtReqStatus = "sent";
        });
    },

    formatString(str, indexArray, char) {
      for (var i = 0; i < indexArray.length; i++) {
        str =
          str.slice(0, indexArray[i] + i) + char + str.slice(indexArray[i] + i);
      }
      return str;
    }
  }
};
</script>


<style lang="scss">
.tran_discounted {
  font-size: 12px !important;
}

.tran_sent {
  color: green;
}

.text__error {
  font-weight: bold;
  color: red;
}
</style>

<style lang="scss" scoped>
.table__key {
  display: none;
}

@media (min-width: 1230px) {
  thead {
    display: table-header-group;
  }

  tr {
    display: table-row;
  }

  th,
  td {
    text-align: center;
  }

  .table__key {
    display: table-cell;
    width: auto;
    .table__cell--content {
      font-size: 1em;
    }
  }

  .table__cell--label {
    display: none;
  }

  .table__actions {
    text-align: right;
  }
}
</style>
